import React from 'react';
import { View } from 'react-native';
import PanelHeadline from './PanelHeadline';
import SubHeadlineFullPagePanel from '../Text/SubHeadlineFullPagePanel';

//= ========================================================================

const PanelHeadlineContainer = ({
  headline,
  subheading,
  paragraph,
}) => (
  <View>
    <PanelHeadline text={headline} />
    {subheading && <PanelHeadline text={subheading} isSubheading />}
    <SubHeadlineFullPagePanel>{paragraph}</SubHeadlineFullPagePanel>
  </View>
);
export default PanelHeadlineContainer;
